import ctaDesktop from "@assets/images/hsa-fsa/cta-desktop.webp";
import ctaSd from "@assets/images/hsa-fsa/cta-sd.webp";
import ctaTablet from "@assets/images/hsa-fsa/cta-tablet.webp";
import Button from "@/blueprint/components/Button/Button";
import ResponsiveArt from "@/blueprint/components/ResponsiveArt/ResponsiveArt";
import ScrollReveal from "@/blueprint/components/ScrollReveal/ScrollReveal";
import Section from "@/blueprint/components/Section/Section";
import Text from "@/blueprint/components/Text/Text";
import { SITE_LINKS } from "@/data/siteLinks";
import { HSA_FSA_CTA } from "@/views/hsa-fsa/hsaFsaContent";

const HsaFsaCta = ({ position }: { position: number }) => (
  <Section
    id="hsa-fsa-cta"
    position={position}
    ariaLabelledBy="hsa-fsa-cta-heading"
    className="relative flex min-h-[435px] flex-col items-center justify-center overflow-hidden py-[72px] tab:py-[96px] sd:min-h-[520px] sd:py-[128px]"
  >
    {/* Figma's mobile frame stretches the tablet crop into half the width, so
        mobile shows the tablet art at its own scale, anchored left instead. */}
    <ResponsiveArt
      sources={{
        mobile: ctaTablet,
        tablet: ctaTablet,
        sd: ctaSd,
        desktop: ctaDesktop,
      }}
      alt={HSA_FSA_CTA.mediaAlt}
      sizes="(max-width: 799.98px) 834px, 100vw"
      className="absolute inset-0 h-full w-full object-cover object-left tab:object-center"
    />

    <div className="mx-auto flex w-full max-w-container flex-col items-center gap-[20px] px-grid-margin tab:gap-[24px] sd:gap-[32px] d:gap-[40px]">
      <ScrollReveal className="relative">
        <Text
          variant="h3"
          as="h2"
          className="relative text-center text-brand-white"
        >
          <span id="hsa-fsa-cta-heading">{HSA_FSA_CTA.headline}</span>
        </Text>
      </ScrollReveal>
      <ScrollReveal className="relative" delayMs={80}>
        <Button
          variant="solid-inverse"
          href={SITE_LINKS.matic.href}
          className="relative"
        >
          {HSA_FSA_CTA.ctaLabel}
        </Button>
      </ScrollReveal>
    </div>
  </Section>
);

export default HsaFsaCta;
